<template>
  <div>
    <!-- <component
      :is="scrollbarTag"
      class="chat-content-scroll-area"
      :style="{ position: ' relative', 'max-height': maxHeight }"
      :settings="settings"
      ref="chatLogPS"
      :key="$vs.rtl"
    > -->
      <div class="chat__log" ref="chatLog">
        <comment-log :data="data"></comment-log>
      </div>
    <!-- </component> -->
    <div class="chat__input flex p-4 bg-white">
      <vs-input
        class="flex-1"
        :placeholder="placeholder"
        v-model="comment"
        @keyup.enter="send"
      />
      <vs-button
        class="bg-primary-gradient ml-4"
        type="filled"
        icon-pack="feather"
        icon="icon-send"
        @click="send"
      >
      </vs-button>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import CommentLog from '@/views/components/CommentLog.vue'

export default {
  components: {
    VuePerfectScrollbar,
    CommentLog
  },
  props: {
    data: {
      type: Array,
      default: () => [],
      required: true
    },
    placeholder: {
      type: String,
      default: 'Type Your Message'
    },
    maxHeight: {
      type: String,
      default: '200px'
    }
  },
  data() {
    return {
      comment: '',
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7
      }
    }
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    send() {
      if (this.comment !== '') {
        this.$emit('send', this.comment)
        //const scroll_el = this.$refs.chatLogPS.$el || this.$refs.chatLogPS
        //scroll_el.scrollTop = this.$refs.chatLog.scrollHeight
        this.comment = ''
      }
    },
    toggleIsChatPinned(value) {
      this.isChatPinned = value
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.isChatSidebarActive = this.clickNotClose = false
      } else {
        this.isChatSidebarActive = this.clickNotClose = true
      }
    },
    toggleChatSidebar(value = false) {
      if (!value && this.clickNotClose) return
      this.isChatSidebarActive = value
    }
  },
  created() {
    this.setSidebarWidth()
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/apps/chat.scss';
</style>
